'use client';

import { useEffect, useRef } from 'react';

export function Clock({ className }: { className?: string }) {
	const ref = useRef<HTMLSpanElement>(null);

	useEffect(() => {
		const prefersReduced =
			typeof window !== 'undefined' &&
			window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		let rafId: number | null = null;
		let intervalId: ReturnType<typeof setInterval> | null = null;
		let lastRender = 0;

		const render = () => {
			if (ref.current) {
				const d = new Date();
				const ms = d.getMilliseconds().toString().padStart(3, '0').slice(0, 2);
				ref.current.textContent = `${d.toISOString().slice(11, 19)}:${ms}`;
			}
		};

		if (prefersReduced) {
			render();
			intervalId = setInterval(render, 60_000);
			return () => {
				if (intervalId) clearInterval(intervalId);
			};
		}

		const tick = (now: number) => {
			if (now - lastRender >= 50) {
				lastRender = now;
				render();
			}
			rafId = requestAnimationFrame(tick);
		};
		rafId = requestAnimationFrame(tick);
		return () => {
			if (rafId) cancelAnimationFrame(rafId);
		};
	}, []);

	return (
		<span
			ref={ref}
			className={className ? `data-mono ${className}` : 'data-mono'}
			suppressHydrationWarning
		>
			00:00:00:00
		</span>
	);
}
